import React, { Component } from 'react';
import { PropTypes, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import { withCookies, Cookies } from 'react-cookie';
import BSAccountService from '../../services/BSAccountService';
import CookieStorageService from '../../services/CookieStorageService';
import ChromeExtensionService from '../../services/ChromeExtensionService';
import Header from '../shared/Header';
import Footer from '../shared/Footer';
import CongratsContent from './CongratsContent';
import * as session_handlers from '../../actions/session_handler';
import { AVATAR_ID_COOKIE, AVATAR_UUID_COOKIE, BSAUTH_COOKIE,
    LOGIN_TOKEN_TYPE_BSAUTH, LOGIN_TOKEN_TYPE_SNAPCHAT
} from '../../constants/cookie_constants';

import './CongratsView.css';

const getInitialState = () => ({
    avatarId: '',
    errorMsg: ''
});

class CongratsView extends Component {
    constructor(props) {
        super(props);
        this.state = getInitialState();
    }

    componentWillMount() {
        const { session, cookies } = this.props;


        ChromeExtensionService.sendMessage({ signal: 'BitmojiWebAppCheckUserLoggedIn' },
            (response) => {

                if ((typeof response !== 'undefined') && response.signal === 'ChromeExtUserLoggedIn') {

                    if (session.loginTokenType === LOGIN_TOKEN_TYPE_BSAUTH ) {

                        const bsAuthToken = CookieStorageService.get(BSAUTH_COOKIE, cookies);
                        BSAccountService.getAvatarInfo(bsAuthToken)
                            .then((avatarData) => {
                                CookieStorageService.set(AVATAR_ID_COOKIE,
                                    avatarData.id, cookies);
                                CookieStorageService.set(AVATAR_UUID_COOKIE,
                                    avatarData.avatar_version_uuid, cookies);

                                this.setState({avatarId: avatarData.id, errorMsg: ''});
                            }).catch(() => {
                                CookieStorageService.clearAllCookies(cookies);
                                this.props.updateLoginSession(false, null);
                            });
                    }
                    else if(session.loginTokenType === LOGIN_TOKEN_TYPE_SNAPCHAT) {
                        CookieStorageService.set(AVATAR_ID_COOKIE, response.avatarData.id, cookies);
                        this.setState({avatarId: response.avatarData.id, errorMsg: ''});
                    }

                } else {

                    // user not logged in or chrome ext is not installed
                    CookieStorageService.clearAllCookies(cookies);
                    this.props.updateLoginSession(false, null);
                }
            });
    }

    render() {
         return (
            <div className="congrats-view">
                <Header />
                <CongratsContent avatarId={this.state.avatarId}/>
                <Footer />
            </div>
        );
    }
}

CongratsView.propTypes = {
    session: PropTypes.object.isRequired,
    updateLoginSession: PropTypes.func.isRequired,
    cookies: instanceOf(Cookies).isRequired
};

export default connect(state => ({
    session: state.sessionReducer
}), session_handlers)(withCookies(CongratsView));



// WEBPACK FOOTER //
// ./src/components/congrats_view/CongratsView.js